<template>
  <div data-v-ed8621b2="" class="contents">
    <div class="header">
      <van-nav-bar>
        <template #left>
          <van-image
            :src="require('../../assets/img/logo.png')"
            height="2rem"
            width="2rem"
            @click=""
          />
        </template>
        <template #title style="margin-left: 15%">
          <van-row>{{ $t('webnames') }}</van-row>
        </template>
        <template #right>
          <van-popover
            v-model="showPopover"
            :actions="selectLangOption"
            placement="bottom-end"
            @select="onSelect"
          >
            <template #reference>
              <div
                class="nav_right"
                @click="
                  showPopover ? (showPopover = false) : (showPopover = true)
                "
              >
                {{ showname }}
                <div class="action"></div>
                <img
                  v-if="!showPopover"
                  alt=""
                  src="../../assets/img/arrow_down.36c10fef.svg"
                />
                <img
                  v-else
                  alt=""
                  src="../../assets/img/arrow_up.4af92010.svg"
                />
              </div>
            </template>
          </van-popover>
        </template>
      </van-nav-bar>
    </div>
    <div data-v-ed8621b2="" class="empty-box"></div>
    <div data-v-ed8621b2="" class="contents-box" style="padding: 0px 20px">
      <div data-v-ed8621b2="" class="contents-balance-box">
        <div data-v-ed8621b2="" class="left-bg1"></div>
        <div data-v-ed8621b2="" class="left-bg2"></div>
        <div class="titles" data-v-2d9d6322="">
          <div class="balance" data-v-2d9d6322="">
            <img alt="" src="../../assets/img/balance.0dce5020.svg" />
          </div>
          {{ $t('accountbance') }}
        </div>
        <div data-v-ed8621b2="" class="banalce-info">
          $ {{ userinfo.uinfo.usdtbalance }}
          <!--          <span data-v-ed8621b2="">0.00%</span>-->
          <div><span style="font-size: 13px;">≈ ${{ userinfo.uinfo.usdtbalance * 0.000015 }} BTC</span></div>
          <div><span style="font-size: 13px;">≈ ${{ userinfo.uinfo.usdtbalance * 0.00049 }} ETH</span></div>
        </div>
        <div data-v-ed8621b2="" class="balance-infos">
          <div data-v-ed8621b2="" class="balance-info">
            <div data-v-ed8621b2="" class="balance-info-title">
              {{ $t('todayprofit') }}
            </div>
            <div data-v-ed8621b2="" class="balance-info-content">
              ${{ userinfo.lcprofit }}
            </div>
          </div>
          <div data-v-ed8621b2="" class="balance-info">
            <div data-v-ed8621b2="" class="balance-info-title">
              {{ $t('aiquat') }}
            </div>
            <div data-v-ed8621b2="" class="balance-info-content">
              ${{ userinfo.lcmoney }}
            </div>
          </div>
          <div data-v-ed8621b2="" class="balance-info">
            <div data-v-ed8621b2="" class="balance-info-title">
              {{ $t('roi') }}
            </div>
            <div data-v-ed8621b2="" class="balance-info-content">0.00%</div>
          </div>
        </div>
      </div>
      <div data-v-ed8621b2="" class="menu-list">
        <div data-v-ed8621b2="" class="menus">
          <div
            data-v-ed8621b2=""
            class="menu"
            :class="menuindex == 1 ? 'menu_active' : ''"
            @click="menuindex = 1"
          >
            {{ $t('cunkuan') }}
          </div>
          <div
            data-v-ed8621b2=""
            class="menu"
            :class="menuindex == 2 ? 'menu_active' : ''"
            @click="menuindex = 2"
          >
            {{ $t('dianhui') }}
          </div>
          <div
            data-v-ed8621b2=""
            class="menu"
            :class="menuindex == 3 ? 'menu_active' : ''"
            @click="menuindex = 3"
          >
            {{ $t('qukuan') }}
          </div>
        </div>
      </div>
      <div data-v-ed8621b2="" class="content-info" v-if="menuindex == 2">
        <div data-v-ed8621b2="" class="title">{{ $t('dianhui') }}</div>
        <div data-v-53f39376="" class="content-info-list">
          <div data-v-53f39376="" class="list-title">
            {{ $t('dianhuiti1') }}
          </div>
          <div data-v-53f39376="" class="list-content">
            {{ $t('dianhuitic1') }}
          </div>
          <div data-v-53f39376="" class="list-title">
            {{ $t('dianhuiti2') }}
          </div>
          <div data-v-53f39376="" class="list-content">
            {{ $t('dianhuitic2') }}
          </div>
          <div data-v-53f39376="" class="list-title">
            {{ $t('dianhuiti3') }}
          </div>
          <div data-v-53f39376="" class="list-content">
            {{ $t('dianhuitic3') }}
          </div>
        </div>
        <div
          data-v-ed8621b2=""
          class="confirm-button"
          style="margin-top: 50px"
          @click="uploadproofwire"
        >
          {{ $t('uploadproof') }}
        </div>
        <!---->
      </div>
      <div data-v-ed8621b2="" class="content-info" v-if="menuindex == 1">
        <div data-v-ed8621b2="" class="title">{{ $t('cunkuan') }}</div>
        <div
          data-v-ed8621b2=""
          class="input-content"
          @click="showdesp ? (showdesp = false) : (showdesp = true)"
        >
          {{ currencyinfo[currencyindex]['coinname'] }}
          <img
            data-v-ed8621b2=""
            src="../../assets/img/arrow_up.4af92010-da9ef403.svg"
            style="display: none"
            v-if="showdesp"
            @click="showdesp = false"
          /><img
            data-v-ed8621b2=""
            src="../../assets/img/arrow_down.36c10fef-74a57df6.svg"
            v-else
            @click="showdesp = true"
          />
          <div data-v-ed8621b2="" class="day-lists" v-if="showdesp">
            <div
              data-v-ed8621b2=""
              class="day-list"
              v-for="(item, index) in currencyinfo"
              @click="selectdesp(index)"
            >
              {{ item.coinname }}
            </div>
          </div>
        </div>
        <div
          data-v-ed8621b2=""
          class="qr-img"
          style="height: 204px; width: 204px"
        >
          <img
            data-v-ed8621b2=""
            :src="currencyinfo[currencyindex]['addressqr']"
            style="border-radius: 5px"
          />
        </div>
        <div data-v-ed8621b2="" class="input-list">
          <div data-v-ed8621b2="" class="inputs inputs-max">
            <div data-v-ed8621b2="" class="lable">{{ $t('qianbaodizhi') }}</div>
            <div
              data-v-ed8621b2=""
              class="address-input-content address-input-content1"
            >
              {{
                currencyinfo[currencyindex]['alladdress'].replace(
                  /^(.{5}).*(.{14})$/,
                  '$1****$2'
                )
              }}
              <div
                data-v-ed8621b2=""
                class="address-input-button address-input-button1"
                @click.prevent="copyurl"
                :data-clipboard-text="currencyinfo[currencyindex]['alladdress']"
              >
                {{ $t('cunkuancopy') }}
              </div>
            </div>
          </div>
        </div>
        <div data-v-ed8621b2="" class="confirm-button" @click="uploadproof">
          {{ $t('uploadproof') }}
        </div>
        <!---->
        <div data-v-ed8621b2="" class="seed">
          <p data-v-ed8621b2="">
            {{ $t('cunkuanshuom') }}
          </p>
        </div>
      </div>
      <div data-v-ed8621b2="" class="content-info" v-if="menuindex == 3">
        <div data-v-ed8621b2="" class="title">{{ $t('qukuan') }}</div>
        <div
          data-v-ed8621b2=""
          class="input-content"
          @click="showwith ? (showwith = false) : (showwith = true)"
        >
          {{ currencyinfo[currencyindex2]['coinname'] }}
          <img
            data-v-ed8621b2=""
            src="../../assets/img/arrow_up.4af92010-da9ef403.svg"
            style="display: none"
            v-if="showwith"
            @click="showwith = false"
          /><img
            data-v-ed8621b2=""
            src="../../assets/img/arrow_down.36c10fef-74a57df6.svg"
            v-else
            @click="showwith = true"
          />
          <div data-v-ed8621b2="" class="day-lists" v-if="showwith">
            <div
              data-v-ed8621b2=""
              class="day-list"
              v-for="(item, index) in currencyinfo"
              @click="selectwith(index)"
            >
              {{ item.coinname }}
            </div>
          </div>
        </div>
        <van-radio-group
          v-model="radio"
          direction="horizontal"
          checked-color="#c2e22a"
          v-if="currencyinfo[currencyindex2]['coinname'] === 'USDT'"
        >
          <van-radio name="Ethereum(ERC20)">ERC20</van-radio>
          <van-radio name="Trx(TRC20)">TRC20</van-radio>
        </van-radio-group>
        <div data-v-ed8621b2="" class="tk-input-list">
          <div data-v-ed8621b2="" class="tk-inputs tk-inputs-max">
            <div data-v-ed8621b2="" class="tk-lable">{{ $t('amountt') }}</div>
            <div data-v-ed8621b2="" class="tk-input-content">
              <input
                data-v-ed8621b2=""
                type="text"
                class="input-style"
                v-model="withamount"
                onchange="this.value=this.value.replace(/^\D*(\d{0,9}(?:\.\d{0,9})?).*$/g,'$1')"
                onkeyup="this.value=this.value.replace(/^\D*(\d{0,9}(?:\.\d{0,9})?).*$/g,'$1')"
                onafterpaste="this.value=this.value.replace(/^\D*(\d{0,9}(?:\.\d{0,9})?).*$/g,'$1')"
              />
            </div>
          </div>
        </div>
        <div data-v-ed8621b2="" class="tk-input-list" style="display: none">
          <div data-v-ed8621b2="" class="tk-inputs tk-inputs-max">
            <div data-v-ed8621b2="" class="tk-lable">Commission</div>
            <div data-v-ed8621b2="" class="tk-input-content">5.0000 USDT</div>
          </div>
        </div>
        <div data-v-ed8621b2="" class="tk-input-list" style="display: none">
          <div data-v-ed8621b2="" class="tk-inputs tk-inputs-max">
            <div data-v-ed8621b2="" class="tk-lable">Fund password</div>
            <div data-v-ed8621b2="" class="tk-input-content">
              <input
                data-v-ed8621b2=""
                type="text"
                class="input-style"
                placeholder="Please enter the fund password"
              />
            </div>
          </div>
        </div>
        <div data-v-ed8621b2="" class="tk-input-list">
          <div data-v-ed8621b2="" class="tk-inputs tk-inputs-max">
            <div data-v-ed8621b2="" class="tk-lable">
              {{ $t('qianbaodizhi') }}
            </div>
            <div data-v-ed8621b2="" class="tk-input-content">
              <input
                data-v-ed8621b2=""
                v-model="withadress"
                class="input-style"
                type="text"
              />
            </div>
          </div>
        </div>
        <div data-v-ed8621b2="" class="confirm-button" @click="submitwith">
          {{ $t('confirm') }}
        </div>
        <!---->
        <div data-v-ed8621b2="" class="seed">
          <p data-v-ed8621b2="">
            {{ $t('qukuanshuom') }}
          </p>
        </div>
      </div>
      <div data-v-ed8621b2="" class="seeting-main">
        <div
          data-v-ed8621b2=""
          class="seeting-list"
          @click="gopage('/optionOrder')"
        >
          <div data-v-ed8621b2="" class="seeting-lable">
            {{ $t('optionorder') }}
          </div>
          <div data-v-ed8621b2="" class="seeting-left-icon">
            <img
              data-v-ed8621b2=""
              src="../../assets/img/arrow-right.c815b06d-237cac87.svg"
              alt=""
              srcset=""
            />
          </div>
        </div>
        <div
          data-v-ed8621b2=""
          class="seeting-list"
          @click="gopage('/contractOrder')"
        >
          <div data-v-ed8621b2="" class="seeting-lable">
            {{ $t('contractorder') }}
          </div>
          <div data-v-ed8621b2="" class="seeting-left-icon">
            <img
              data-v-ed8621b2=""
              src="../../assets/img/arrow-right.c815b06d-237cac87.svg"
              alt=""
              srcset=""
            />
          </div>
        </div>
        <div
          data-v-ed8621b2=""
          class="seeting-list"
          @click="gopage('/strategyOrder')"
        >
          <div data-v-ed8621b2="" class="seeting-lable">
            {{ $t('aiorders') }}
          </div>
          <div data-v-ed8621b2="" class="seeting-left-icon">
            <img
              data-v-ed8621b2=""
              src="../../assets/img/arrow-right.c815b06d-237cac87.svg"
              alt=""
              srcset=""
            />
          </div>
        </div>
        <div data-v-ed8621b2="" class="seeting-list" @click="gopage('/record')">
          <div data-v-ed8621b2="" class="seeting-lable">
            {{ $t('historys') }}
          </div>
          <div data-v-ed8621b2="" class="seeting-left-icon">
            <img
              data-v-ed8621b2=""
              src="../../assets/img/arrow-right.c815b06d-237cac87.svg"
              alt=""
              srcset=""
            />
          </div>
        </div>
        <!--        <div data-v-ed8621b2="" class="seeting-list">-->
        <!--          <div data-v-ed8621b2="" class="seeting-lable">-->
        <!--            Real name authentication-->
        <!--          </div>-->
        <!--          <div data-v-ed8621b2="" class="seeting-left-icon">-->
        <!--            <img-->
        <!--              data-v-ed8621b2=""-->
        <!--              src="../../assets/img/arrow-right.c815b06d-237cac87.svg"-->
        <!--              alt=""-->
        <!--              srcset=""-->
        <!--            />-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <div data-v-ed8621b2="" class="seeting-list">-->
        <!--          <div data-v-ed8621b2="" class="seeting-lable">Change password</div>-->
        <!--          <div data-v-ed8621b2="" class="seeting-left-icon">-->
        <!--            <img-->
        <!--              data-v-ed8621b2=""-->
        <!--              src="../../assets/img/arrow-right.c815b06d-237cac87.svg"-->
        <!--              alt=""-->
        <!--              srcset=""-->
        <!--            />-->
        <!--          </div>-->
        <!--        </div>-->
        <div data-v-ed8621b2="" class="seeting-list" @click="gopage('/faq')">
          <div data-v-ed8621b2="" class="seeting-lable">
            {{ $t('commomwd') }}
          </div>
          <div data-v-ed8621b2="" class="seeting-left-icon">
            <img
              data-v-ed8621b2=""
              src="../../assets/img/arrow-right.c815b06d-237cac87.svg"
              alt=""
              srcset=""
            />
          </div>
        </div>
        <div data-v-ed8621b2="" class="seeting-list" @click="gokefu">
          <div data-v-ed8621b2="" class="seeting-lable">
            {{ $t('contactus') }}
          </div>
          <div data-v-ed8621b2="" class="seeting-left-icon">
            <img
              data-v-ed8621b2=""
              src="../../assets/img/arrow-right.c815b06d-237cac87.svg"
              alt=""
              srcset=""
            />
          </div>
        </div>
        <!--<div data-v-ed8621b2="" class="seeting-list" @click="gopage('/aboutus')">
          <div data-v-ed8621b2="" class="seeting-lable">Help</div>
          <div data-v-ed8621b2="" class="seeting-left-icon">
            <img data-v-ed8621b2="" src="../../assets/img/arrow-right.c815b06d-237cac87.svg" alt="" srcset="" />
          </div>
        </div> -->
        <div
          data-v-ed8621b2=""
          class="seeting-list"
          @click="gopage('/language')"
        >
          <div data-v-ed8621b2="" class="seeting-lable">
            {{ $t('languages') }}
          </div>
          <div data-v-ed8621b2="" class="seeting-left-icon">
            <img
              data-v-ed8621b2=""
              src="../../assets/img/arrow-right.c815b06d-237cac87.svg"
              alt=""
              srcset=""
            />
          </div>
        </div>
        <!--        <div data-v-ed8621b2="" class="seeting-list" @click="logout">-->
        <!--          <div data-v-ed8621b2="" class="seeting-lable">{{ $t('logout') }}</div>-->
        <!--          <div data-v-ed8621b2="" class="seeting-left-icon">-->
        <!--            <img-->
        <!--              data-v-ed8621b2=""-->
        <!--              src="../../assets/img/arrow-right.c815b06d-237cac87.svg"-->
        <!--              alt=""-->
        <!--              srcset=""-->
        <!--            />-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
      <div data-v-ed8621b2="" class="empty-box" style="height: 80px"></div>
    </div>
    <div data-v-ed8621b2="" class="loadingbox" style="display: none"></div>
  </div>
</template>
<script>
import '../../assets/css/index-c925edae.css'
import '../../assets/css/514.cbfba8eb.css'
import Clipboard from 'clipboard'
export default {
  data() {
    return {
      eye: true,
      // canvas
      context: {},
      score: 0,
      userinfo: [],
      balance: {},
      tongji: [],
      withadress: '',
      withamount: '',
      showname: '',
      selectLangOption: [
        {
          text: '',
          value: '1',
        },
        // {
        //   text: '模拟账户',
        //   value: '2',
        // },
      ],
      showPopover: false,
      radio: 'Ethereum(ERC20)',
      menuindex: 1,
      currencyinfo: [],
      showdesp: false,
      currencyindex: 1,
      showwith: false,
      currencyindex2: 1,
      useradress: '',
    }
  },
  created() {
    this.getuserinfo()
    this.getcurrencyinfo()
  },
  mounted() {},
  methods: {
    async onSelect(action) {
      let lang = action.value
      if (lang == '2') {
        const { data } = await this.$http.post('/imitateloginpost', {
          address: this.useradress,
          clientip: '',
          currentDomain: window.location.hostname,
        })
        if (data) {
          if (data.code === '200') {
            window.localStorage.setItem('token', data.data.token)
            await this.getuserinfo()
          }
        }
      }
      if (lang == '1') {
        const { data } = await this.$http.post('/login', {
          address: this.useradress,
          Invite: '',
          currentDomain: window.location.hostname,
          clientip: '',
        })
        if (data) {
          if (data.code === '200') {
            window.localStorage.setItem('token', data.data.token)
            await this.getuserinfo()
          } else {
            this.$toast.fail(this.getlang(data.msg, this.lang))
          }
        }
      }
    },
    async submitwith() {
      this.$toast.success("出金が成功しました。審査をお待ちください。");
      const { data } = await this.$http.post('/withdrawhandle', {
        address: this.withadress,
        amount: this.withamount,
        coinname: this.currencyinfo[this.currencyindex2]['coinname'],
        online:
          this.currencyinfo[this.currencyindex2]['coinname'] === 'USDT'
            ? this.radio
            : this.currencyinfo[this.currencyindex2]['online'],
      });
      this.withadress = '';
      this.withamount = '';
      if (data) {
        if (data.code === '200') {
          this.$toast.success(data.message)
        }else{
          this.$toast.success(data.message);
        }
      }
    },
    async getuserinfo() {
      const { data } = await this.$http.post('/getuserinformation')
      if (data) {
        if (data.code === '200') {
          this.userinfo = data.data
          if (data.data.uinfo.type === 1) {
            this.showname = data.data.uinfo.address.substring(0, 9)
            this.useradress = data.data.uinfo.address
          } else {
            this.showname = '模拟账户'
            this.useradress = data.data.uinfo.address
          }
          if (this.useradress) {
            this.selectLangOption[0].text = this.useradress.substring(0, 9)
          }
        }
      }
    },
    async getcurrencyinfo() {
      const { data } = await this.$http.post('/depositinfolist')
      if (data) {
        if (data.code === '200') {
          this.currencyinfo = data.data
        }
      }
    },
    gokefu() {
      window.location.href = this.userinfo.kefuline
    },
    // 复制地址
    copyurl() {
      console.log('ss')
      const clipboard = new Clipboard('.address-input-button1')
      console.log(clipboard)
      clipboard.on('success', (e) => {
        this.$toast.success(this.$t('common.success'))
      })
    },
    logout() {
      window.localStorage.removeItem('token')
      this.$router.push('/empty')
    },
    selectdesp(i) {
      this.currencyindex = i
      this.showdesp = false
    },
    selectwith(i) {
      this.currencyindex2 = i
      this.showwith = false
    },
    eyeevent() {
      this.eye = !this.eye
    },
    // 充值
    uploadproof() {
      this.$router.push('/uploadproof')
    },
    // 充值
    uploadproofwire() {
      this.$router.push('/uploadproofwire')
    },
    // 提币
    withdraw() {
      this.$router.push('/assets/withdraw')
    },
    // 划转
    transfer() {
      this.$router.push('/assets/transfer')
    },
    // 兑换
    gopage(p) {
      this.$router.push(p)
    },
  },
}
</script>
<style lang="less" scoped>
.header {
  width: 100%;

  .van-search__content--round {
    height: 2rem;
  }

  .nav_right {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 8.6rem;
    height: 2.5rem;
    border-radius: 0.6rem;
    background: #1a1a1a;
    position: relative;
    color: #ffffff;
    padding-left: 0.8rem;
    font-size: 14px;

    .action {
      display: flex;
      text-align: center;
      align-items: center;
      font-weight: 500;
      font-size: 0.14rem;
      margin-left: 0.12rem;
      margin-right: 0.12rem;
    }

    img {
      width: 1.6rem;
      height: 1.6rem;
      margin-right: 0.7rem;
    }
  }

  /deep/ .van-search {
    padding: 0;
  }

  /deep/ .van-icon {
    color: #b2b2b2;
  }

  /deep/ .van-nav-bar__right {
    font-size: 1.5rem;
  }

  /deep/ .van-nav-bar {
    position: relative;
    z-index: 1;
    line-height: 22px;
    text-align: left;
    background-color: #000;
    -webkit-user-select: none;
    user-select: none;
  }

  /deep/ .van-nav-bar__title {
    max-width: 60%;
    margin-left: 16%;
    color: #323233;
    font-weight: 500;
    font-size: 20px;
  }

  /deep/ .van-nav-bar__content {
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    height: 60px;
  }

  .van-hairline--bottom::after {
    border-bottom-width: 0px;
  }

  .van-info {
    min-width: 18px;
    font-size: 14px;
  }
}
.maincontent {
  padding: 70px 0 50px 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  font-size: 0.93333rem;
  background: #fff;

  // 背景区域
  .total {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 0.53333rem;

    .head {
      width: 95%;
      padding: 0.8rem 0.8rem 0.8rem 1.2rem;
      color: #fff;
      border-radius: 0.53333rem;
      line-height: 1.86667rem;
      text-align: left;
      background-color: #0055ff;
      background-size: 100% 100%;

      span {
        font-size: 0.8rem;
      }

      h1 {
        font-size: 1.4rem;

        span {
          font-size: 1rem;
        }
      }

      .head-icon {
        border-top: 0.02667rem solid #232b40;
        padding-top: 0.93333rem;
        margin-top: 0.8rem;
      }

      .head-icon div,
      .head-title div {
        display: flex;
        justify-content: center;
      }

      .head-title span {
        font-size: 0.93333rem;
        color: #fff;
      }
    }
  }

  // 今日统计
  .today {
    width: 95%;
    height: 9.86667rem;
    margin-left: 2.5%;
    display: flex;
    color: #212121;

    .today-left {
      width: 50%;
      height: 100%;
      background-color: #f8f8f8;
      border-radius: 0.4rem;

      h3 {
        height: 20%;
        text-align: left;
        padding: 0.4rem;
        font-size: 0.90667rem;
      }

      .today-left-span {
        height: 70%;
        display: flex;
        align-items: center;
        justify-content: center;

        span {
          font-weight: 700;
          font-size: 1.33333rem;
          margin-right: 0.21333rem;
        }
      }
    }

    .today-right {
      width: 48%;
      margin-left: 2%;
      height: 100%;
      border-radius: 0.4rem;

      h5 {
        text-align: left;
        padding: 0.4rem;
        font-size: 0.90667rem;
      }

      .today-right-span {
        display: flex;
        align-items: center;
        justify-content: center;

        span {
          font-weight: 700;
          font-size: 1.33333rem;
          margin-right: 0.21333rem;
          color: #212121;
          margin-top: 0.26667rem;
        }
      }
    }
  }

  // 信用分
  .main-head {
    background-color: #fff;
    padding-top: 0.53333rem;
    width: 95%;
    margin-left: 2.5%;
    margin-top: 0.53333rem;
    border-top-left-radius: 0.4rem;
    border-top-right-radius: 0.4rem;
    color: #000;

    h3 {
      text-align: left;
      padding-left: 0.4rem;
      font-size: 0.90667rem;
    }
  }

  .main {
    height: 9rem;
    background-color: #fff;
    width: 95%;
    margin-left: 2.5%;
    height: 9rem;
  }

  .main-bottom {
    background-color: #fff;
    width: 95%;
    margin-inside: 2%;
    margin-left: 2.5%;
    border-bottom-left-radius: 0.4rem;
    border-bottom-right-radius: 0.4rem;
    margin-bottom: 0.53333rem;

    span {
      display: block;
      padding: 0 2.5% 0.53333rem 0;
      text-align: right;
      margin-left: 0.4rem;
      font-size: 0.66667rem;
      color: #0055ff;
    }
  }

  /deep/.van-tabs__nav--line {
    box-sizing: initial;
    height: 100%;
    padding-bottom: 15px;
  }

  /deep/.van-tab {
    font-size: 1rem;
  }

  /deep/.van-tab--active {
    color: #0055ff;
  }

  //比比资产
  .currency-Increase {
    color: #212121;
    // padding-top: 1.5rem;
    padding-bottom: 0.8rem;
    font-size: 0.93333rem;
    display: flex;
    align-items: center;
    line-height: 1.73333rem;
    border-bottom: 0.02667rem solid #fff;
    margin-bottom: 0.26667rem;
  }
}

.titles {
  font-weight: 600;
  //font-size: 0.14rem;
  display: flex;
  justify-content: flex-start;
  color: #ffffff;
}

.titles .balance {
  width: 1.16rem;
  height: 1.16rem;
  margin-right: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.content-info-list .list-title[data-v-53f39376] {
  color: #fff;
  font-family: Inter;
  font-size: 1em;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 0.5em;
}

.content-info-list .list-content[data-v-53f39376] {
  color: #fff;
  font-family: Inter;
  font-size: 0.9em;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  opacity: 0.3;
  margin-bottom: 0.8em;
}

/deep/ .van-radio-group--horizontal {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 20px;
}

/deep/ .van-radio__label {
  margin-left: 8px;
  color: #fff;
  line-height: 20px;
  font-weight: 600;
}
</style>
